import React, { useState } from "react";
import "./PAMMCommissionSettings.css";
import { Save, Plus, Edit, Trash2 } from "lucide-react";

function PAMMCommissionSettings() {
  const [settings, setSettings] = useState([
    { id: 1, tierName: "Level 1 - Master IB", commissionType: "Percentage", commissionValue: "2.5%", minVolume: "$100,000", status: "Active" },
    { id: 2, tierName: "Level 2 - Sub IB", commissionType: "Percentage", commissionValue: "1.5%", minVolume: "$50,000", status: "Active" },
    { id: 3, tierName: "Level 3 - Direct Referral", commissionType: "Percentage", commissionValue: "0.5%", minVolume: "$10,000", status: "Active" },
    { id: 4, tierName: "Performance Bonus", commissionType: "Fixed", commissionValue: "$500", minVolume: "$500,000", status: "Active" },
  ]);

  const [generalSettings, setGeneralSettings] = useState({
    payoutFrequency: "Monthly",
    minPayout: "$100",
    autoPayment: true,
    commissionCap: "$50,000",
  });

  return (
    <div className="pamm-settings-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>PAMM Commission Settings</h1>
          <div className="header-bottom">
            <h2 className="view-all">Configure commission tiers and payout settings</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn create-btn">
            <Plus size={16} /> Add New Tier
          </button>
          <button className="btn orange">
            <Save size={16} /> Save All
          </button>
        </div>
      </div>

      {/* General Settings Card */}
      <div className="settings-card">
        <h3>General Payout Settings</h3>
        <div className="settings-grid">
          <div className="setting-field">
            <label>Payout Frequency</label>
            <select 
              value={generalSettings.payoutFrequency}
              onChange={(e) => setGeneralSettings({...generalSettings, payoutFrequency: e.target.value})}
            >
              <option>Daily</option>
              <option>Weekly</option>
              <option>Monthly</option>
              <option>Quarterly</option>
            </select>
          </div>
          <div className="setting-field">
            <label>Minimum Payout Amount</label>
            <input 
              type="text" 
              value={generalSettings.minPayout}
              onChange={(e) => setGeneralSettings({...generalSettings, minPayout: e.target.value})}
            />
          </div>
          <div className="setting-field">
            <label>Monthly Commission Cap</label>
            <input 
              type="text" 
              value={generalSettings.commissionCap}
              onChange={(e) => setGeneralSettings({...generalSettings, commissionCap: e.target.value})}
            />
          </div>
          <div className="setting-field">
            <label>Auto Payment</label>
            <div className="toggle-switch">
              <input 
                type="checkbox" 
                id="autoPayment"
                checked={generalSettings.autoPayment}
                onChange={(e) => setGeneralSettings({...generalSettings, autoPayment: e.target.checked})}
              />
              <label htmlFor="autoPayment" className="toggle-label">
                {generalSettings.autoPayment ? "Enabled" : "Disabled"}
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Commission Tiers Table */}
      <div className="settings-card">
        <h3>Commission Tiers</h3>
        <div className="table-container">
          <table className="pamm-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Tier Name</th>
                <th>Commission Type</th>
                <th>Commission Value</th>
                <th>Min Volume Required</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {settings.map((setting, index) => (
                <tr key={setting.id}>
                  <td>{index + 1}</td>
                  <td>{setting.tierName}</td>
                  <td>
                    <span className={`type-badge ${setting.commissionType.toLowerCase()}`}>
                      {setting.commissionType}
                    </span>
                  </td>
                  <td className="value">{setting.commissionValue}</td>
                  <td>{setting.minVolume}</td>
                  <td>
                    <span className={`status ${setting.status === "Active" ? "success" : "warning"}`}>
                      {setting.status}
                    </span>
                  </td>
                  <td>
                    <button className="icon-btn" title="Edit">
                      <Edit size={18} />
                    </button>
                    <button className="icon-btn danger" title="Delete">
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Performance Bonus Settings */}
      <div className="settings-card">
        <h3>Performance Bonus Criteria</h3>
        <div className="settings-grid">
          <div className="setting-field">
            <label>Bonus Trigger (Monthly Volume)</label>
            <input type="text" defaultValue="$500,000" />
          </div>
          <div className="setting-field">
            <label>Bonus Amount</label>
            <input type="text" defaultValue="$500" />
          </div>
          <div className="setting-field">
            <label>Bonus Type</label>
            <select defaultValue="Fixed">
              <option>Fixed</option>
              <option>Percentage</option>
            </select>
          </div>
          <div className="setting-field">
            <label>Max Bonus Per Month</label>
            <input type="text" defaultValue="$5,000" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Vista FX Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMCommissionSettings;
